module.exports = __webpack_public_path__ + "fonts/iconfont.6b7348f4.eot";